import { motion } from "framer-motion";
import { css, styled } from "styled-components";

const Container = styled.div<{ $hasHorizontalScroll: boolean }>`
  width: 100%;
  display: inline-flex;
  align-items: center;

  padding: 0 1rem;
  gap: 1rem;
  overflow-x: auto;
  ${({ $hasHorizontalScroll }) =>
    !$hasHorizontalScroll &&
    css`
      justify-content: center;
    `}
`;

const Network = styled.div<{ $isActive: boolean }>`
  position: relative;
  cursor: pointer;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  gap: 0.25rem;

  padding: 0.25rem;

  border-radius: 0.625rem;
  border: 1px solid transparent;
  opacity: 0.7;

  ${({ $isActive, theme }) =>
    $isActive &&
    css`
      border: 1px solid ${theme.colors.borderNetwork};
      background: ${theme.colors.surfaceNetwork};
      opacity: 1;
    `}
  transition: all 0.2s ease;

  & > svg {
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const Text = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 0.25rem;
  & > div {
    &:first-of-type {
      color: ${({ theme }) => theme.colors.black};
      font-family: ${({ theme }) => theme.fonts.manrope};
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 700;
      line-height: 0.625rem;
    }
  }
`;

const ScoreAmount = styled(motion.div)`
  position: absolute;
  bottom: 0;

  display: flex;
  line-height: 0.625rem;
  & > p {
    color: ${({ theme }) => theme.colors.black};
    font-size: 0.75rem;
    line-height: 0.625rem;
    font-weight: 400;

    &:last-of-type {
      opacity: 0.5;
    }
  }
`;

const Dot = styled.div`
  position: absolute;

  width: 0.5rem;
  height: 0.5rem;
  top: -1px;
  right: -1px;

  border: 1px solid ${({ theme }) => theme.colors.surfaceNetwork};
  background-color: ${({ theme }) => theme.colors.red};
  border-radius: 50%;
`;

export default {
  Container,
  Network,
  Text,
  ScoreAmount,
  Dot,
};
